import React from "react";
import InputBox from 'components/reusable/InputBox';
import CookieManager from "utilities/js/localstorage/CookieManager";
import {search} from "utilities/js/callouts/CalloutFactory";
import './SearchForm.css';
import SearchResultsDisplayFullScreen from "./SearchResultsDisplayFullScreen";
import { isClickInBox } from "utilities/js/ClickPositionHelper";

let cookieManager = new CookieManager();

class SearchForm extends React.Component {

    constructor(props){
        super(props);
        

        this.formContainerRef = React.createRef();

        this.state = {
            searchTerm: '',
            searchResults: null,
            placeholder: this.props.placeholder ? this.props.placeholder : 'search...',
            errorDisplay: '',
            areResultsOpen: false,

            toastMessages: []
        };
        
        this.setSearchTerm = this.setSearchTerm.bind(this);  
        this.areInputsValid = this.areInputsValid.bind(this);
        this.search = this.search.bind(this);  

    }

    componentDidMount(){
        this.allowSubmitOnEnter();
        document.addEventListener('click', this.closeResultsOnOutsideClick.bind(this));
    }

    

    /*********************** Search Logic **************************/
    search(){
        if(this.areInputsValid()){
            this.setState({"isLoading": true});

            let table = 'bracket';
            if(this.state.searchTerm && this.state.searchTerm.length > 0 && this.state.searchTerm[0] === '@'){
                table = 'account';
            }
            
            search({term: this.state.searchTerm, table: table}).then(response => {

                console.log(response);
                this.setState({searchResults: response, errorDisplay: '', areResultsOpen: true});
                if(this.props.callback){
                    this.props.callback(response);
                }

            }).catch((error) => {
                let errorDisplay = 'Something went wrong.';
                if(error.code){
                    errorDisplay = error.message;
                }
                this.setState({errorDisplay: errorDisplay});
                console.log(error);
            }).finally(() => {
                setTimeout(() => {
                    this.setState({"isLoading": false});
                }, 2000);
            })
        }

    }


    areInputsValid(){
        let errorDisplay;
        if(this.state.searchTerm){
            if(this.state.searchTerm.length < 3){
                errorDisplay = 'Your search must be at least 2 characters in length';
            }
            if(this.state.searchTerm[0] === '@' && this.state.searchTerm.length < 4){
                errorDisplay = 'Your search must be at least 2 characters in length';
            }

        }else{
            
            errorDisplay = 'Your search must be at least 2 characters in length';
        }

        if(errorDisplay){
            this.setState({errorDisplay: errorDisplay});
            return false;
        }

        return true;
    }

    allowSubmitOnEnter(){
        let container = this.formContainerRef.current.addEventListener("keypress", function(event) {
            if (event.key === "Enter") {
                //TODO: perform a check to see if the cursor is in a text box or the select button
                let searchButton = event.currentTarget.querySelector("#search-button");

                event.preventDefault();
                if(searchButton){
                    searchButton.click();
                }
            }
        });
    }

    /******************************* Input Setters  ************************************/
    setSearchTerm(event){
        this.setState({searchTerm: event.target.value});

        if(!event.target.value || (event.target.value && event.target.value.length)){
            if(this.props.callback){
                this.props.callback(null);
            }
            this.setState({areResultsOpen: false});
        }
        //TODO: Disable the search button if less than 3 characters have been entered
    }


    /*********************** Screen flow controls ***********************/

     
    closeResultsOnOutsideClick(event) {
        //TODO: evaluate because this may act strangely if multiple search inputs are on the same screen
        let searchBar = document.querySelector('.search-screen-content-container');
        let searchResults = document.querySelector('.search-results-container-full-screen');
        if(searchResults){
            if (!isClickInBox(event.x, event.y, searchBar.getBoundingClientRect()) && !isClickInBox(event.x, event.y, searchResults.getBoundingClientRect())) {
                this.setState({areResultsOpen: false})
            }
        }
    }



    /*********************** UI Render Helpers ***********************/

    getSearchInputDisplay(){
        let errorMessages = <></>
        if(this.state.errorDisplay){
            errorMessages = <div className="error-messages">{this.state.errorDisplay}</div>
        }

        let inputClass = 'search-styled-input-light';
        if(this.state.areResultsOpen){
            inputClass = 'search-styled-input-light dropdown';
        }

        let screenForm = (
            <>
                <div className="search-form-container">
                    <div className="search-input-container">
                        <div className="search-form-label-text"></div>
                        <InputBox uniqueKey="searchTerm" key="searchTerm" name='searchTerm' type="search" placeholder={this.state.placeholder} class={inputClass} value={this.state.searchTerm} valueChangedCallback={this.setSearchTerm}></InputBox>
                    </div>
                    <div className="search-button-container">
                        <button id="search-button" label='search-user' className='search-button' disabled={this.state.isLoading} onClick={this.search}>Search</button>
                    </div>
                </div>
            </>
        );
    
        return ( 
            <div ref={this.formContainerRef} className="search-screen-content-container">
                {screenForm}
                <div className="search-results-anchor">
                    {this.getSearchResultsDisplay()}
                </div>
            </div>
        )
        
    }

    getSearchResultsDisplay(){
        if(this.state.areResultsOpen){
            return ( 
                <SearchResultsDisplayFullScreen searchTerm={this.state.searchTerm} searchResults={this.state.searchResults}></SearchResultsDisplayFullScreen>
            )
        }
    }

    render(){
        return (
            <>
                {this.getSearchInputDisplay()}
            </>
        );
    }
}

export default SearchForm;
